export default {
  config() {
    if (window?.ssrConfig?.routerConfig?.renderWechatJssdk?.config) {
      return new Promise((resolve, reject) => {
        console.log('\n\nwindow.ssrConfig.routerConfig.renderWechatJssdk: ', window.ssrConfig.routerConfig.renderWechatJssdk)
        const { config } = window.ssrConfig.routerConfig.renderWechatJssdk;
        wx.config(config);
        wx.ready(() => resolve(wx));
        wx.error(res => reject(res));
      });
    }
    return undefined;
  },
  share() {
    if (window?.ssrConfig?.routerConfig?.renderWechatJssdk?.shared) {
      console.log('share start !!')
      const { shared } = window.ssrConfig.routerConfig.renderWechatJssdk;
      const shareData = {
        title: shared?.title ?? '',
        link: shared?.link ?? '',
        imgUrl: shared?.imgUrl ?? ''
      };
      wx.updateTimelineShareData(Object.assign({}, shareData, {
        success: function () {
          window.wownowonLog('updateTimelineShareData-分享朋友圈');
        },
        fail: function(e) {
          console.log('share fail')
          console.log(e)
        },
        complete: function() {
          console.log('share complete')
        }
      }));
      if (shared?.desc) {
        shareData.desc = shared.desc;
      };
      wx.updateAppMessageShareData(Object.assign({}, shareData, {
        success: function () {
          window.wownowonLog('updateAppMessageShareData-分享 QQ');
        }
      }));
      wx.onMenuShareWeibo(Object.assign({}, shareData, {
        success: function () {
          window.wownowonLog('onMenuShareWeibo-分享到微博');
        },
        cancel: function () {
          window.wownowonLog('onMenuShareWeibo-取消分享到微博');
        }
      }))
    }
  }
}